import apiClient from "../api"

const authHeaders = () => {
  const token = localStorage.getItem("token")
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export const submitEcommerceRequest = async (storeId, payload) => {
  try {
    const response = await apiClient.post(`gestock/stores/${storeId}/ecommerce-requests`, payload, {
      headers: authHeaders(),
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const getLatestEcommerceRequest = async (storeId) => {
  try {
    const response = await apiClient.get(`gestock/stores/${storeId}/ecommerce-requests/latest`, {
      headers: authHeaders(),
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}
